module.exports = __webpack_public_path__ + "static/media/thadeuro_end.9c5580c8.png";